import axios from "axios";
import cookie from "react-cookies";
import { v4 as uuid } from "uuid";
import { DEFAULT_LANGUAGE, HEADER, COOKIE } from "./../util/constants";

const API_URL = process.env.REACT_APP_API_URL;
const API_KEY = process.env.REACT_APP_API_KEY;

// Constants
const deviceId = cookie.load(COOKIE.DEVICE) ? cookie.load(COOKIE.DEVICE) : uuid();
const deviceOS = "web";
const brandId =
  process.env.REACT_APP_BRAND === "renault"
    ? "c2e9b958-7108-4185-bf31-e87171fc267f"
    : "64dca812-d7df-4111-b03e-48c2d538465b";

// delay function
function waitFor(millSeconds) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve();
    }, millSeconds);
  });
}

// Save device id
cookie.save(COOKIE.DEVICE, deviceId, { path: "/" });

async function getAppointmentNoteCategoryParents() {
  return (
    axios
      .get(API_URL + "/appointments/categories/web", {
        headers: {
          [HEADER.LANGUAGE]: DEFAULT_LANGUAGE,
          [HEADER.AUHTORIZATION]: API_KEY,
        },
      })
      // Success
      .then((result) => {
        // Failed
        if (result.data.error) return Promise.reject(result.data.error);

        // Return dealers
        return result.data.data.noteParentCategories;
      })
      // Error
      .catch((e) => Promise.reject(e))
  );
}

async function getDealers() {
  return (
    axios
      .get(API_URL + "/dealers/web", {
        headers: {
          [HEADER.LANGUAGE]: DEFAULT_LANGUAGE,
          [HEADER.AUHTORIZATION]: API_KEY,
        },
        params: {
          fullObject: true,
        },
      })
      // Success
      .then((result) => {
        // Failed
        if (result.data.error) return Promise.reject(result.data.error);
        let dealersFiltered = result.data.data.dealers.filter(
          (dealer) =>
            (dealer.isSale && !dealer.isVale && !dealer.isService) ||
            (!dealer.isSale && !dealer.isVale && !dealer.isService)
        );

        // Filter dealers
        let filteredDealers = result.data.data.dealers.filter(
          (dealer) => !dealersFiltered.includes(dealer)
        );

        // Update specific dealer name for code "98456"
        filteredDealers = filteredDealers.map((dealer) => {
          if (dealer.code === "98456") {
            return {
              ...dealer,
              name: "OTOMOL",
            };
          }
          return dealer;
        });

        // Return dealers
        return filteredDealers;
      })
      // Error
      .catch((e) => Promise.reject(e))
  );
}

async function getTimeSlots(dealerId) {
  return (
    axios
      .get(API_URL + "/appointments/time-slots/web", {
        headers: {
          [HEADER.LANGUAGE]: DEFAULT_LANGUAGE,
          [HEADER.AUHTORIZATION]: API_KEY,
        },
        params: {
          dealerId,
        },
      })
      // Success
      .then((result) => {
        // Failed
        if (result.data.error) return Promise.reject(result.data.error);

        // Return dealers

        return result.data.data.timeSlots;
      })
      // Error
      .catch((e) => Promise.reject(e))
  );
}

async function getCampaigns() {
  return (
    axios
      .get(API_URL + "/campaigns/web?isWeb=true&published=true", {
        headers: {
          [HEADER.LANGUAGE]: DEFAULT_LANGUAGE,
          [HEADER.AUHTORIZATION]: API_KEY,
          [HEADER.BRAND]: brandId,
        },
      })
      // Success
      .then((result) => {
        // Failed
        if (result.data.error) return Promise.reject(result.data.error);

        // Return dealers
        return result.data.data.campaigns;
      })
      // Error
      .catch((e) => Promise.reject(e))
  );
}

async function getFormerDealer(vehicleInfo) {
  return (
    axios
      .post(
        API_URL + "/appointments/web/request",
        { vehicleInfo },
        {
          headers: {
            [HEADER.LANGUAGE]: DEFAULT_LANGUAGE,
            [HEADER.AUHTORIZATION]: API_KEY,
            [HEADER.BRAND]: brandId,
          },
        }
      )
      // Success
      .then((result) => {
        // Failed
        if (result.data.error) return Promise.reject(result.data.error);

        // Return dealers
        return result.data.data;
      })
      // Error
      .catch((e) => Promise.reject(e))
  );
}

async function createAppointment(data, isPortLogin) {
  const headers = {
    [HEADER.AUHTORIZATION]: API_KEY,
    [HEADER.LANGUAGE]: DEFAULT_LANGUAGE,
  };

  if (isPortLogin) {
    headers[HEADER.AUHTORIZATION] = cookie.load(COOKIE.AUHTORIZATION);
    headers[HEADER.DEVICE] = deviceId;
    headers[HEADER.DEVICE_OS] = deviceOS;
    headers[HEADER.BRAND] = brandId;
    headers["isPortLogin"] = true;
  } else {
    headers["isPortLogin"] = false;
    headers[HEADER.BRAND] = brandId;
  }

  return (
    axios
      .post(API_URL + "/appointments/web", data, {
        headers,
      })
      // Success
      .then((result) => {
        // Failed
        if (result.data.error) return Promise.reject(result.data.error);

        // Return dealers
        return result.data.data.appointment;
      })
      // Error
      .catch((e) => Promise.reject(e))
  );
}

async function sendVerificationCode(body) {
  const token = cookie.load(COOKIE.AUHTORIZATION);

  return (
    axios
      .post(API_URL + "/customers/verifications/phone", body, {
        headers: {
          // [HEADER.AUHTORIZATION]: token,
          [HEADER.LANGUAGE]: DEFAULT_LANGUAGE,
          [HEADER.DEVICE]: deviceId,
          [HEADER.DEVICE_OS]: deviceOS,
          [HEADER.BRAND]: brandId,
        },
      })
      // Success
      .then((result) => {
        // Failed
        if (result.data.error) return Promise.reject(result.data.error);

        // Save cookie
        cookie.save(COOKIE.AUHTORIZATION, result.headers[HEADER.AUHTORIZATION], { path: "/" });

        // Return
        // return result.headers[HEADER.CUSTOMER_TYPE] === 0
        return result.data.data.isAlreadyUser;
      })
      // Error
      .catch((e) => Promise.reject(e))
  );
}

async function getVerificationCode(phone) {
  const token = cookie.load(COOKIE.AUHTORIZATION);

  return (
    axios
      .get(API_URL + "/customers/verifications/phone", {
        headers: {
          // [HEADER.AUHTORIZATION]: token,
          [HEADER.LANGUAGE]: DEFAULT_LANGUAGE,
          [HEADER.DEVICE]: deviceId,
          [HEADER.DEVICE_OS]: deviceOS,
          [HEADER.BRAND]: brandId,
        },
        params: {
          phone,
        },
      })
      // Success
      .then((result) => {
        // Failed
        if (result.data.error) return Promise.reject(result.data.error);

        // Save cookie
        cookie.save(COOKIE.AUHTORIZATION, result.headers[HEADER.AUHTORIZATION], { path: "/" });

        // Return
        return result.data.data.phoneVerification.id;
      })
      // Error
      .catch((e) => Promise.reject(e))
  );
}

async function sendVerificationCodeWOLogin(appointmentId, data) {
  return (
    axios
      .patch(API_URL + "/appointments/web/" + appointmentId, data, {
        headers: {
          [HEADER.LANGUAGE]: DEFAULT_LANGUAGE,
          [HEADER.AUHTORIZATION]: API_KEY,
          [HEADER.BRAND]: brandId,
        },
      })
      // Success
      .then((result) => {
        // Failed
        if (result.data.error) return Promise.reject(result.data.error);

        // Return dealers
        return {};
      })
      // Error
      .catch((e) => Promise.reject(e))
  );
}

async function getVerificationCodeWOLogin(phone) {
  return axios.get(API_URL + "/campaigns", {
    headers: {
      [HEADER.LANGUAGE]: DEFAULT_LANGUAGE,
    },
  });
}

async function getCustomer() {
  const token = cookie.load(COOKIE.AUHTORIZATION);

  return (
    axios
      .get(API_URL + "/vehicles/customers/self/web", {
        headers: {
          [HEADER.AUHTORIZATION]: token,
          [HEADER.LANGUAGE]: DEFAULT_LANGUAGE,
          [HEADER.DEVICE]: deviceId,
          [HEADER.DEVICE_OS]: deviceOS,
          [HEADER.BRAND]: brandId,
        },
      })
      // Success
      .then((result) => {
        // Failed
        if (result.data.error) return Promise.reject(result.data.error);

        // Return
        return result.data.data.customer;
      })
      // Error
      .catch((e) => Promise.reject(e))
  );
}

async function getAppointmentDetail(appointmentId) {
  const token = cookie.load(COOKIE.AUHTORIZATION);

  return (
    axios
      .get(API_URL + "/appointments/web/" + appointmentId, {
        headers: {
          [HEADER.AUHTORIZATION]: token,
          [HEADER.LANGUAGE]: DEFAULT_LANGUAGE,
          [HEADER.DEVICE]: deviceId,
          [HEADER.DEVICE_OS]: deviceOS,
          [HEADER.BRAND]: brandId,
        },
      })
      // Success
      .then((result) => {
        // Failed
        if (result.data.error) return Promise.reject(result.data.error);

        // Return
        return result.data.data.appointment;
      })
      // Error
      .catch((e) => Promise.reject(e))
  );
}

async function cancelAppointment(appointmentId) {
  const token = cookie.load(COOKIE.AUHTORIZATION);

  return (
    axios
      .get(API_URL + "/appointments/web/" + appointmentId + "/cancel", {
        headers: {
          [HEADER.AUHTORIZATION]: token,
          [HEADER.LANGUAGE]: DEFAULT_LANGUAGE,
          [HEADER.DEVICE]: deviceId,
          [HEADER.DEVICE_OS]: deviceOS,
          [HEADER.BRAND]: brandId,
        },
      })
      // Success
      .then((result) => {
        // Failed
        if (result.data.error) return Promise.reject(result.data.error);

        // Return
        return result.data.data.isCanceled;
      })
      // Error
      .catch((e) => Promise.reject(e))
  );
}

export {
  getAppointmentDetail,
  getCampaigns,
  getAppointmentNoteCategoryParents,
  getDealers,
  getTimeSlots,
  sendVerificationCode,
  getVerificationCode,
  sendVerificationCodeWOLogin,
  getVerificationCodeWOLogin,
  getFormerDealer,
  createAppointment,
  getCustomer,
  cancelAppointment,
};
